/**
 * Company strips — seamless auto-scrolling logo marquee.
 *
 * The Blade template renders two identical .company-strips-group elements.
 * Here we measure the distance between the two groups (which accounts for
 * the collapsed -1px borders), clone extra groups until the track always
 * covers the viewport mid-animation, and feed the CSS animation its scroll
 * distance and duration so the speed stays constant regardless of how many
 * logos the editor adds. Pausing on hover is handled in CSS via
 * animation-play-state.
 */

const SCROLL_SPEED = 40; // px per second

export function initCompanyStrips() {
    const blocks = document.querySelectorAll('.block-company-strips');
    if (!blocks.length) return;

    blocks.forEach((block) => {
        const viewport = block.querySelector('.company-strips-viewport');
        const track = block.querySelector('.company-strips-track');
        if (!viewport || !track) return;

        const setup = () => {
            track.querySelectorAll('[data-clone]').forEach((el) => el.remove());

            const groups = track.querySelectorAll('.company-strips-group');
            if (groups.length < 2) return;

            // Distance from the start of one group to the start of the next —
            // this is the exact translateX needed for a seamless loop.
            const shift = groups[1].offsetLeft - groups[0].offsetLeft;
            if (shift <= 0) return;

            // Make sure the track still covers the viewport at max translate.
            while (track.scrollWidth < viewport.offsetWidth + shift * 2) {
                const clone = groups[1].cloneNode(true);
                clone.setAttribute('data-clone', '');
                track.appendChild(clone);
            }

            track.style.setProperty('--strips-shift', `-${shift}px`);
            track.style.setProperty('--strips-duration', `${shift / SCROLL_SPEED}s`);
        };

        setup();

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(setup, 150);
        });
    });
}
